import { createAction } from 'redux-actions';
import { APP_LOADED, TransactionTypes } from '../../../settings/settings';

export const loadApplication = (actions) => {
  return (dispatch) => {
    Promise.all([
      actions.getPersonalInformation(),
      dispatch(actions.getExistingBanks()),
      dispatch(actions.getProductTypes()),
      dispatch(actions.getRMDLimits()),
      dispatch(actions.getUserFunds(TransactionTypes.SELL)),
      dispatch(actions.getBankMaps()),
    ])
      .then(() => {
        dispatch(actions.getExistingBanksSerivceFeatures());
      })
      .then(
        () => {
          actions.getUserMessages();
          dispatch(createAction(`${APP_LOADED}_FULFILLED`)(true));
          dispatch(actions.getMoneyMarketEvent());
          dispatch(actions.getMoneyMarketEventMessage());
          dispatch(actions.getUserPaperlessSetting());
          dispatch(actions.getPendingTransactions());
          dispatch(actions.getRedeemThresholds());
          dispatch(actions.getTransactionLimits());
          dispatch(actions.getUncollectedShares());
          actions.getTransactionHistory();
          actions.getTransactionHistoryYTD();
          actions.getStateWithholdingData();
          actions.getCostBasisInformation();
          actions.getSystematicPurchases();
          actions.getSystematicRedemptions();
          actions.getSystematicExchanges();
          actions.getMarketVolatilityInformation();
          actions.getAutoMaxPOAs();
          actions.setProgress(1);
        },
        () => {
          const action = createAction(`${APP_LOADED}_REJECTED`)(true);
          dispatch(action);
        }
      );
  };
};
